import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e9efec2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-header"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "账号简称", -1));
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "域名组", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "域名", -1));
const _hoisted_10 = {
  class: "right"
};
import { getSelectAggre } from '@/api/payManage/domian';
// import { filterOption } from '@/common'
export default /*#__PURE__*/_defineComponent({
  __name: 'HostHeader',
  emits: ['returnSearch', 'resetDimension'],
  setup(__props, {
    expose,
    emit
  }) {
    let accountName = ref(undefined);
    let domainGroup = ref(undefined);
    let hostGroupList = ref([]);
    let accountList = ref([]);
    let domainUrl = ref('');
    let activeKey = ref('1');
    // 重置搜索条件
    let resetSearch = () => {
      accountName.value = undefined;
      domainGroup.value = undefined;
      domainUrl.value = '';
      search();
    };
    let changeTabs = () => {
      search();
    };
    // 搜索方法
    let search = () => {
      let searchObj = {
        accountName: accountName.value,
        domainGroup: domainGroup.value,
        domainUrl: domainUrl.value
      };
      emit('returnSearch', searchObj);
    };
    const filterOption = (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase().trim()) >= 0;
    };
    // 方法留着后期会用
    const changeType = () => {
      emit('resetDimension', activeKey.value);
    };
    // 查询账号和域名组下拉
    const querySelectAggre = async () => {
      let params = {
        marketType: null
      };
      try {
        const {
          code,
          data
        } = await getSelectAggre(params);
        if (code === '0') {
          accountList.value = data.accountList.map(item => {
            item.label = item.accountName;
            return item;
          });
          hostGroupList.value = data.domainGroups.map(item => {
            item.label = item.domainGroup;
            return item;
          });
        }
      } catch (e) {}
    };
    onMounted(() => {
      querySelectAggre();
      search();
    });
    expose({
      resetSearch,
      changeTabs
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_select, {
        "show-search": "",
        allowClear: "",
        value: _unref(accountName),
        "onUpdate:value": _cache[0] || (_cache[0] = $event => _isRef(accountName) ? accountName.value = $event : accountName = $event),
        placeholder: "请选择账号简称",
        options: _unref(accountList),
        "filter-option": filterOption,
        "field-names": {
          label: 'label',
          value: 'label'
        }
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_select, {
        allowClear: "",
        value: _unref(domainGroup),
        "onUpdate:value": _cache[1] || (_cache[1] = $event => _isRef(domainGroup) ? domainGroup.value = $event : domainGroup = $event),
        placeholder: "请选择域名组",
        options: _unref(hostGroupList),
        "field-names": {
          label: 'label',
          value: 'label'
        },
        "filter-option": filterOption
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_input, {
        value: _unref(domainUrl),
        "onUpdate:value": _cache[2] || (_cache[2] = $event => _isRef(domainUrl) ? domainUrl.value = $event : domainUrl = $event),
        valueModifiers: {
          trim: true
        },
        allowClear: "",
        placeholder: "请输入域名搜索"
      }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
        onClick: _unref(resetSearch)
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _unref(search)
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      }, 8, ["onClick"])])])]);
    };
  }
});